import {
  ApolloError,
  MutationFunctionOptions,
  MutationHookOptions,
  MutationResult,
  QueryHookOptions,
  useMutation,
  useQuery,
} from '@apollo/client';
import { FetchResult } from '@apollo/client/link/core';
import { forecastDataQuery } from '@e2m-customer-portal/hooks';
import { defaultForecastQuery, defaultForecastMutation } from './query-definitions';
import { clearCache } from '../../../utils';
import {
  ChangeDefaultForecastMutation,
  ChangeDefaultForecastMutationVariables,
  DefaultForecastInput,
  DefaultForecastQuery,
  DefaultForecastQueryVariables,
} from '../../../generated/graphql';

export const useDefaultForecast = (
  deviceId: string,
  options?: QueryHookOptions<DefaultForecastQuery, DefaultForecastQueryVariables>,
): { loading: boolean | undefined; data: DefaultForecastQuery | undefined; error: ApolloError | undefined } => {
  const { data, error, loading } = useQuery<DefaultForecastQuery, DefaultForecastQueryVariables>(defaultForecastQuery, {
    ...options,
    variables: { deviceId },
    errorPolicy: 'all',
  });
  return { loading: loading, data: data, error: error };
};

export const useDefaultForecastMutation = (
  options?: MutationHookOptions<ChangeDefaultForecastMutation, ChangeDefaultForecastMutationVariables>,
): [
  (
    deviceId: string,
    forecast: ReadonlyArray<DefaultForecastInput>,
    options?: MutationFunctionOptions<ChangeDefaultForecastMutation, ChangeDefaultForecastMutationVariables>,
  ) => Promise<FetchResult<ChangeDefaultForecastMutation>>,
  MutationResult<ChangeDefaultForecastMutation>,
] => {
  const [update, response] = useMutation<ChangeDefaultForecastMutation, ChangeDefaultForecastMutationVariables>(
    defaultForecastMutation,
    options,
  );

  return [
    (deviceId, forecast, opts?) =>
      update({
        ...opts,
        variables: {
          deviceId,
          forecast,
        },
        update: clearCache(forecastDataQuery),
      }),
    response,
  ];
};
